<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

<!-- Tabs Navigation -->
<nav class="tabs-nav">
  <div class="container">
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'articles'"
      (click)="setActiveTab('articles')">
      <i class="pi pi-book"></i> NOS ARTICLES
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'actualites'"
      (click)="setActiveTab('actualites')">
      <i class="pi pi-calendar"></i> ACTUALITÉS
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'faq'"
      (click)="setActiveTab('faq')">
      <i class="pi pi-question-circle"></i> FAQ
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'documents'"
      (click)="setActiveTab('documents')">
      <i class="pi pi-file"></i> DOCUMENTS
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'glossaire'"
      (click)="setActiveTab('glossaire')">
      <i class="pi pi-book"></i> GLOSSAIRE
    </button>
  </div>
</nav>

<!-- Content Section -->
<section class="blog-content">
  <div class="container">
    
    <!-- Articles Tab -->
    <div *ngIf="activeTab === 'articles'">

      <div *ngIf="chargement" class="articles-etat">Chargement des articles…</div>

      <div *ngIf="!chargement && erreur" class="articles-etat">
        Les articles ne sont pas disponibles pour le moment. Réessayez dans un instant.
      </div>

      <div *ngIf="!chargement && !erreur && articles.length === 0" class="articles-etat">
        Aucun article publié pour le moment.
      </div>

      <div *ngIf="!chargement && !erreur && articles.length > 0" class="articles-grid">
        <article *ngFor="let article of articles" class="article-card">
          <div class="article-image">
            <img [src]="imageArticle(article)" [alt]="article.cover_alt || article.titre"
                 loading="lazy" />
          </div>
          <div class="article-content">
            <span class="article-category" *ngIf="article.categorie">{{ article.categorie }}</span>
            <h3 class="article-title">{{ article.titre }}</h3>
            <p class="article-excerpt">{{ resume(article) }}</p>
            <div class="article-meta">
              <span *ngIf="article.publie_le">{{ article.publie_le | date:'d MMMM y':'':'fr' }}</span>
              <span *ngIf="article.temps_lecture_min">{{ article.temps_lecture_min }} min de lecture</span>
            </div>
            <!-- href et non routerLink : l'article est une page HTML statique
                 hors SPA, seule version lisible par les moteurs de recherche
                 et les moteurs de réponse IA. -->
            <a [href]="article.url" class="article-link">Voir Plus</a>
          </div>
        </article>
      </div>
    </div>

    <!-- FAQ Tab -->
    <div *ngIf="activeTab === 'faq'" class="faq-section">
      <h2>Questions fréquentes sur le changement de son Assurance de Prêt</h2>
      <div class="faq-list">
        <div *ngFor="let item of faqItems" class="faq-item">
          <h3 class="faq-question">{{ item.question }}</h3>
          <p class="faq-answer">{{ item.answer }}</p>
        </div>
      </div>
    </div>

    <!-- Other Tabs (placeholder) -->
    <div *ngIf="activeTab === 'actualites'" class="placeholder-content">
      <i class="pi pi-calendar" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Actualités</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

    <div *ngIf="activeTab === 'documents'" class="placeholder-content">
      <i class="pi pi-file" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Documents</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

    <div *ngIf="activeTab === 'glossaire'" class="placeholder-content">
      <i class="pi pi-book" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Glossaire</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

  </div>
</section>

</app-page-layout>
